export default "__VITE_ASSET__BocENaBI__"